<div class="min-h-screen flex justify-center bg-[#F5F8F9] relative overflow-hidden">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-8 relative z-10 w-full justify-center">

        <!-- Left Side: Login -->
        <div class="col-span-1 md:col-span-6 flex flex-col justify-center items-center py-10 px-6 sm:px-10 lg:px-16">
            <div class="md:max-w-md md:mx-12 mx-4 flex flex-col w-full shrink">
                <!-- Language Toggle -->
                <app-language-toggle extraClass="sm:mb-12 mb-6"></app-language-toggle>

                <!-- Logo -->
                <img src="assets/images/logo-sm.png" [alt]="'LOGIN.LOGO_ALT' | translate" class="mx-auto mb-0" />

                <!-- Heading -->
                <h2
                    class="lg:text-[32px] sm:text-2xl text-[23px] font-semibold text-(--text-primary) text-center leading-9 lg:mx-5 mb-4 mt-8">
                    {{
                    'LOGIN.TITLE' | translate }}</h2>
                <p class="text-center font-medium text-base mb-8 text-(--text-muted)">{{ 'LOGIN.SUBTITLE'
                    | translate }}</p>

                <!-- Login Form -->
                <form [formGroup]="loginForm" class="space-y-4" (ngSubmit)="onLogin()">
                    <!-- Username Field -->

                    <app-input-field label="{{ 'LOGIN.USERNAME' | translate }}"
                        placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"
                        [control]="getControl('username')"></app-input-field>

                    <!-- Password Field -->

                    <app-password-field label="{{ 'LOGIN.PASSWORD' | translate }}"
                        placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" [control]="getControl('password')"
                        [hasError]="hasError('password')">
                    </app-password-field>

                    <div class="text-center my-5"><a routerLink="/forgot-password"
                            class="inline-block text-(--brand-primary) text-base cursor-pointer font-medium transition hover:opacity-80 mb-0">
                            {{'LOGIN.FORGOT_PASSWORD' | translate}}
                        </a></div>


                    <!-- Login Button -->
                    <app-button [text]="'LOGIN.LOGIN' | translate" type="submit" variant="primary" size="lg"
                        extraClass="my-6"></app-button>

                    <!-- Business Onboarding -->
                    <p
                        class="text-(--text-primary) text-center font-medium text-base leading-[140%] tracking-[-0.01em] my-1">
                        {{'LOGIN.NEW_TO' | translate}}
                        <button type="button"
                            class="text-(--brand-primary) ml-1 transition hover:opacity-80 cursor-pointer"
                            (click)="businessOnboarding()">{{'LOGIN.OPEN_ACCOUNT' | translate}}</button>
                    </p>
                </form>
            </div>
        </div>

        <!-- Right Side: Background Image / Slider -->
        <div
            class="md:col-span-6 w-full hidden md:flex relative h-full overflow-hidden rounded-l-4xl rtl:rounded-r-4xl rtl:rounded-l-none ml-auto">

            <img src="assets/images/logo-white.png" [alt]="'LOGIN.LOGO_ALT' | translate"
                class="absolute top-10 left-10" />

            <!-- Dynamic background -->
            <div class="absolute inset-0 w-full h-full bg-cover bg-center shadow-lg -z-10 transition-all duration-700"
                [ngStyle]="{'background-image': 'url(' + sliders[currentSlide].image + ')'}">
            </div>

            <!-- Overlay content -->
            <div
                class="flex items-baseline justify-between w-full lg:pl-14 pl:10 lg:pb-9 pb-5 lg:pr-9 pr-5 lg:flex-row flex-col">
                <div class="flex flex-col justify-end w-full h-full relative z-10 px-4 text-left rtl:text-right">
                    <h5 class="lg:text-4xl text-3xl leading-10 text-white font-semibold lg:mb-10 mb-5"
                        [innerHTML]="sliders[currentSlide].textKey | translate"></h5>

                    <!-- Dots -->
                    <div class="flex gap-2 mt-2">
                        <button *ngFor="let s of sliders; let i = index" class="w-12 h-1.5 rounded-full transition"
                            [ngClass]="{
            'bg-(--brand-primary)': i === currentSlide,
            'bg-[#DAE1E4] hover:bg-(--brand-primary)': i !== currentSlide
          }" (click)="currentSlide = i">
                        </button>
                    </div>
                </div>

                <!-- Arrows -->
                <div class="self-end flex gap-4 lg:pl-9 rtl:pl-0 pl-5 rtl:flex-row-reverse">
                    <button class="group lg:w-14 lg:h-14 w-10 h-10 rounded-full flex items-center justify-center border border-(--color-inactive)
         hover:border-white transition cursor-pointer hover:bg-gray-50/5 relative" (click)="prevSlide()">

                        <!-- Inactive icon (default visible) -->
                        <img src="assets/icons/arrow-left-inactive.svg" [alt]="'SLIDER.LEFT' | translate"
                            class="absolute opacity-100 group-hover:opacity-0 transition-opacity duration-200" />

                        <!-- Active icon (visible on hover) -->
                        <img src="assets/icons/arrow-left-active.svg" [alt]="'SLIDER.LEFT' | translate"
                            class="absolute opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                    </button>


                    <button class="group lg:w-14 lg:h-14 w-10 h-10 rounded-full flex items-center justify-center border border-(--color-inactive)
         hover:border-white transition cursor-pointer hover:bg-gray-50/5 relative" (click)="nextSlide()">

                        <!-- Inactive icon (default visible) -->
                        <img src="assets/icons/arrow-right-inactive.svg" [alt]="'SLIDER.RIGHT' | translate"
                            class="absolute opacity-100 group-hover:opacity-0 transition-opacity duration-200" />

                        <!-- Active icon (visible on hover) -->
                        <img src="assets/icons/arrow-right-active.svg" [alt]="'SLIDER.RIGHT' | translate"
                            class="absolute opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                    </button>

                </div>
            </div>
        </div>
    </div>

    <!-- Bottom-left blur -->
    <div class="fixed top-[700px] w-[1022px] h-[350px] rounded-[50%] bg-[#1654F4]/30 blur-[220px] z-1 select-none pointer-events-none
         -left-[412px] rtl:-right-[412px]">
    </div>

</div>